<!--
 * @Author: houmy
 * @Date: 2023-08-29 18:57:43
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-11-02 12:09:27
 * @FilePath: \zx-home\src\components\Header.vue
 * @Description: 
 * 
-->
<template>
  <div>
    <header class="paddingW64 nav-header">
      <img class="logo" src="@/assets/img/logo1.png" alt="Logo" />
      <div class="nav-menu">
        <el-menu class="menu" :default-active="defaultActive">
          <router-link to="/">
            <el-menu-item index="/">
              首页
            </el-menu-item>
          </router-link>
          <router-link to="/products"><el-menu-item index="/products" @mouseenter.native="showChildren(2, 1)"
              @mouseleave.native="hideChildren">
              产品中心
            </el-menu-item></router-link>
          <router-link to="/solution"><el-menu-item index="/solution" @mouseenter.native="showChildren(3, 1)"
              @mouseleave.native="hideChildren">
              解决方案
            </el-menu-item></router-link>
          <router-link to="/news">
            <el-menu-item index="/news">
              新闻动态
            </el-menu-item></router-link>
          <router-link to="/support">
            <el-menu-item index="/support" @mouseenter.native="showChildren(5, 1)" @mouseleave.native="hideChildren">
              服务支持
            </el-menu-item>
          </router-link>
          <router-link to="/about">
            <el-menu-item index="/about">
              关于我们
            </el-menu-item></router-link>
        </el-menu>
      </div>
      <div class="nav-right">
        <button class="login-button cur-poi commonBtn" @click="goToCloudPlatform"> <img src="../assets/img/cloud.png"
            alt="">
          云平台登录</button>

        <div class="language-switch">
          <div style="cursor: not-allowed;" class="language-switch-text"
            :class="{ active: selectedLanguage === 'english' }">
            EN
          </div>
          <div class="language-switch-divider"></div>
          <div class="language-switch-text" :class="{ active: selectedLanguage === 'chinese' }"
            @click="selectLanguage('chinese')">
            中文
          </div>
        </div>
        <!-- <el-dropdown class="language-dropdown" trigger="click">
            <span class="el-dropdown-link">
              {{ currentLanguage }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click="changeLanguage('en')">EN</el-dropdown-item>
              <el-dropdown-item @click="changeLanguage('zh')">中文</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown> -->
      </div>
    </header>
    <div class="secondMenu" v-show="secondMenuShow" @mouseenter="showChildren(0, 2)" @mouseleave="hideChildren">
      <div class="flag2" v-if="flag == 2">
        <ul class="subMenuTab flex-row">
          <li v-for="(item, index) in subMenu" class="cur-poi" :class="{ 'active': subMenuActive == index }"
            @mouseenter="changeSubMenu(index)">
            {{ item.title }}
          </li>
        </ul>
        <ul class="producRightMain secondMenuMain">
          <li class="flex-col" v-for="(item, index) in productArr" @click="toProductDetail(item, index)">
            <img class="newsImg" :src="getImagePath(item.img)" />
            <h4>{{ item.title.indexOf('自动驾驶')>-1?'自驾'+item.title.split('自动驾驶')[1]:item.title }}</h4>
          </li>

        </ul>
      </div>
      <div class="flag3" v-if="flag == 3">
        <ul class="producRightMain secondMenuMain solutionFlag">
          <li class="flex-col" v-for="(item, index) in productArr" @click="toSolutionDetail(item.id)">
            <img class="newsImg" :src="getImagePath(item.img)" />
            <h4>{{ item.title}}</h4>
          </li>

        </ul>
      </div>
      <div class="flag3" v-if="flag == 5">
        <ul class="subMenuTab flex-row supportSubMenuTab">
          <li v-for="(item, index) in subMenu" class="cur-poi" :class="{ 'active': subMenuActive == index }"
            @click="toSupport(index)">
            {{ item.title }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import productJson from '@/assets/data/productList.json'
import solutionJson from '@/assets/data/solution.json'
export default {
  data() {
    return {
      selectedLanguage: 'chinese',
      activeIndex: 1,
      secondMenuShow: true,
      productArr: [],
      productType: [{
        type: 1,
        title: '智能感知'
      }, {
        type: 2,
        title: '智能驾驶'
      }, {
        type: 3,
        title: '智能硬件'
      }, {
        type: 4,
        title: '智慧云平台'
      }],
      subMenu: [],
      subMenuActive: 0,
      flag: 1,

      supportType: [{
        type: 1,
        title: '常见问题'
      }, {
        type: 2,
        title: '视频中心'
      }, {
        type: 3,
        title: '售后服务政策'
      },{
        type: 4,
        title: '联系方式'
      }]
    };
  },
  mounted() {

    let path = this.$route.path
    let index = 0;
    this.activeIndex = index


  },
  computed: {
    defaultActive() {
      this.selectedLanguage = 'chinese';
      const path = this.$route.path;
      if (path.startsWith('/products')) {
        return '/products';
      } else if (path.startsWith('/news')) {
        return '/news';
      } else if (path.startsWith('/support')) {
        return '/support';
      } else if (path.startsWith('/solution')) {
        return '/solution';
      } else {
        return path;
      }
    },
  },
  methods: {
    // 跳转产品详情
    toProductDetail(item, index) {
      this.$router.push({
        path: '/productsDetail',
        query: {
          id: item.id,
          type: item.type,
        }
      })
    },
    // 跳转解决方案详情
    toSolutionDetail(id) {
      this.$router.push({
        path: '/solutionDetail',
        query: {
          id: id,
        }
      })
    },
    // 跳转服务支持
    toSupport(index) {
      this.subMenuActive = index
      this.$router.push({
        path: '/support',
        query: {
          type: index + 1
        }
      })
    },
    // 图片路径处理
    getImagePath(imageName) {
      return require(`@/assets${imageName}`);
    },
    // 切换二级菜单
    changeSubMenu(type) {
      this.subMenuActive = type
      this.type = type
      this.productArr = productJson[`list${type + 1}`]
    },

    // 展示子菜单
    showChildren(flag, type) {
      if (type == 1) {
        this.subMenuActive = 0
      }
      this.flag = flag ? flag : this.flag
      this.secondMenuShow = true
      if (flag == 2) {
        this.productArr = productJson['list1']
        this.subMenu = this.productType
      }
      if (flag == 3) {
        this.productArr = solutionJson
      }
      if (flag == 5) {
        this.subMenu = this.supportType
      }

    },
    // 隐藏子菜单
    hideChildren() {
      this.secondMenuShow = false
    },
    //  切换语言
    selectLanguage(language) {
      this.selectedLanguage = language;
    },
    // 跳转云平台
    goToCloudPlatform() {
      window.open("http://aifarm.sforceauto.com")
    },
    //  切换语言
    changeLanguage(lang) {
      if (lang === 'en') {
        this.currentLanguage = 'english';
      } else if (lang === 'zh') {
        this.currentLanguage = 'chinese';
      }
    }
  }
};
</script>
<style scoped></style>
  


// WEBPACK FOOTER //
// src/components/Header.vue